export const materialTypes = [
    'ネジ鉄筋',
    '異形棒鋼',
    'カプラー',
    'ロックナット',
    '打継継手',
    'ネジテツコン・せん断筋'
];
